<!-- <button mat-icon-button [matTooltip]="tooltip | translate" [disabled]="disabled" (click)="emitClick($event)"> -->
<button  mat-raised-button color="primary" [matTooltip]="tooltip | translate" [disabled]="disabled" (click)="emitClick($event)">
	<mat-icon color="primary" [svgIcon]="svgIcon"></mat-icon>&nbsp;{{tooltip | translate}}
</button>